// extracted by mini-css-extract-plugin
export var content = "_qy-1";
export var noScroll = "_qy-3";
export var paper = "_qy-0";
export var scrollable = "_qy-2";